import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import errorHandlerBuilder from './errorHandlerBuilder'
import DateUtil from '../util/DateUtil'
import {
  ACTION_QUERY_USER_INFO_LOADING,
  ACTION_QUERY_USER_INFO_LOADED,
  ACTION_QUERY_USER_INFO_ERROR,
  PATH_USER_INFO,
} from '../constants'
import moment from 'moment'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_QUERY_USER_INFO_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_QUERY_USER_INFO_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_USER_INFO}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {
        const userInfo = data.response
        var payload = buildUserInfoPayload(userInfo)
        payload.employers = userInfo.employers
        return {
          type: ACTION_QUERY_USER_INFO_LOADED, payload: payload
        }
      }).catch(errorHandler)

    })
export default epic

export const buildUserInfoPayload = (userInfo) => {

  if(!userInfo) return userInfo

  const {id, name, age, archivable, profileImagePath, dob, accountLocked, enterpriseReference,
    emailAddress, country, city, education, occupation, isMale, userType, dateActivated, dateCreated} = userInfo

  return {
    id,
    name,
    profileImagePath,
    dob,
    age: age || (dob ? moment().year() - parseInt(dob.substring(2)) : null),
    emailAddress,
    country,
    city,
    education,
    occupation,
    isMale,
    archivable,
    accountLocked,
    enterpriseReference,
    registrationDate: dateActivated || dateCreated,
    userType
  }

}




// WEBPACK FOOTER //
// ./src/epics/CurrentUserInfoEpic.js